<ion-tabs>

  <ion-tab-bar slot="botton">


    <ion-tab-button (click)="logOff()">
      <ion-icon name="log-out"></ion-icon>
      <ion-label>Logout</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="tab2">
      <ion-icon name="cog"></ion-icon>
      <ion-label>Transacciones ALO</ion-label>
    </ion-tab-button>

<!--     <ion-tab-button tab="tab3">
      <ion-icon name="list"></ion-icon>
      <ion-label>Transacciones RETO</ion-label>
    </ion-tab-button> -->


  </ion-tab-bar>

</ion-tabs>
